import React from "react";
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../itrust_common/components/AsyncComponent';

const CampaignsListWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/campaigns/campaigns/CampaignsListWrap')
)

const CampaignWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/campaigns/campaign/CampaignWrap')
)

const PatientListWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/groups/group/patients/PatientListWrap')
)

const CampaignsRoutes = (
  <Switch>
    <Route exact path='/marketing-blast/campaigns' component={CampaignsListWrap} />
    <Route exact path='/marketing-blast/campaign/:id' component={CampaignWrap} />
    <Route exact path='/marketing-blast/campaign/:id/patients' component={PatientListWrap} />
    <Route exact path='/marketing-blast/campaign/:id/readonly' component={CampaignWrap} />
  </Switch>
)

export default CampaignsRoutes;